import React, { useState } from 'react';
import Modal from '../../shared/Modal';
import '../blogs.module.css'
import { Mutation } from 'react-apollo';
import { DELETE_BLOG } from '../queries';
import { useHistory } from 'react-router-dom';



const DeleteBlogModal = ({open,toggle,id}) => {

    const history = useHistory();

    return(
        <Mutation mutation={DELETE_BLOG} variables={{id:id}}>
            {(deleteBlog, { loading, error }) => (
                <Modal
                open={open}
                padding="0"
                width="0"
                >
                    <div className='deleteBlogModal'>
                        <div className='deleteBlogHeader'>
                            Delete Blog
                        </div>
                        <div className='deleteBlogBody'>
                            Are you sure you want to delete this blog?
                        </div>
                        <div className='buttonFooter'>
                            <div className='deleteBlogButton' onClick={toggle}>Cancel</div>
                            <div className='deleteBlogButton' style={{color:'#128DFF'}} onClick={() => {
                                deleteBlog().then(() => {history.push(`../blogs`)})
                            }}>Delete</div>
                        </div>

                    </div>

                </Modal>
            )}
        </Mutation>
    )
}

export default DeleteBlogModal;


// WEBPACK FOOTER //
// ./src/components/Blogs/Admin/DeleteBlogModal.js